import { render, staticRenderFns } from "./County.vue?vue&type=template&id=39b720c7&"
import script from "./County.vue?vue&type=script&lang=js&"
export * from "./County.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports